module.exports = __webpack_public_path__ + "img/icon-energy.1527c1da.svg";